import { ContractInvoiceStatus } from "../features/interventions/domains/contract_invoice";
import { FinancialData, FinancialDataType } from "./financial-data";
import { ManualEntryStatus } from "./manual-entry";

export enum FinancialDatasType {
  INCOMES = "INCOMES",
  EXPENSES = "EXPENSES",
}

export class FinancialDatas {
  financialDatas: FinancialData[];
  type: FinancialDatasType;
  total_consumed_bt: number;
  total_projected_bt: number;
  total_amount_due_bt: number;
  total_to_bill_bt: number;
  left_to_bill_bt: number;
  total: number;
  total_cashed: number;
  total_validated_offers: number;
  total_on_going_offers: number;
  total_on_going_offers_amount_bt: number;
  total_validated_offers_amount_bt: number;
  due_late_count: number;

  // CONSOME RECETTES
  get consumedIncomesInvoicesCount() {
    let total = 0;

    total += this.financialDatas.filter((x) => x.type === FinancialDataType.INVOICE).length;

    for (let fd of this.financialDatas) {
      if (fd.type === FinancialDataType.CONTRACT_INVOICE) {
        for (let child of fd.financialDatas) {
          if (child.status !== "DRAFT") {
            total += 1;
          }
        }
      }
    }

    return total;
  }
  get consumedOffersInvoicesCount() {
    return this.financialDatas
      .filter((x) => x.type === FinancialDataType.OFFER && x.status === "VALIDATED")
      .reduce((total, offer) => total + offer.financialDatas.filter((x) => x.status !== "DRAFT").length, 0);
  }

  get consumedOffersInvoicesAmountBt() {
    let total = 0;

    for (let fd of this.financialDatas.filter((x) => x.type === FinancialDataType.OFFER && x.status === "VALIDATED")) {
      for (let invoice of fd.financialDatas.filter((x) => x.status !== "DRAFT")) {
        total += invoice.consumed_amount_bt;
      }
    }
    return total;
  }
  get consumedManualEntriesAmount() {
    let total = 0;

    for (let fd of this.financialDatas.filter((x) => x.type === FinancialDataType.MANUAL_ENTRY)) {
      total += fd.consumed_amount_bt;
    }
    return total;
  }
  get projectedManualEntriesAmount() {
    let total = 0;

    for (let fd of this.financialDatas.filter((x) => x.type === FinancialDataType.MANUAL_ENTRY)) {
      total += fd.projected_amount_bt;
    }
    return total;
  }

  get consumedManualEntriesCount() {
    return this.financialDatas.filter(
      (x) => x.type === FinancialDataType.MANUAL_ENTRY && x.status === ManualEntryStatus.PAID,
    ).length;
  }
  get projectedManualEntriesCount() {
    return this.financialDatas.filter((x) => x.type === FinancialDataType.MANUAL_ENTRY).length;
  }
  get consumedInvoicesAmountBt() {
    let total = 0;

    for (let fd of this.financialDatas.filter((x) => x.type === FinancialDataType.INVOICE && x.status !== "DRAFT")) {
      total += fd.consumed_amount_bt;
    }
    for (let fd of this.financialDatas.filter(
      (x) =>
        x.type === FinancialDataType.CONTRACT_INVOICE &&
        x.status !== ContractInvoiceStatus.TO_INVOICE &&
        x.status !== "DRAFT",
    )) {
      total += fd.consumed_amount_bt;
    }
    return total;
  }

  // CONSOME DEPENSES

  get consumedExpensesInvoicesCount() {
    let total = 0;

    total += this.financialDatas
      .filter((x) => x.type === FinancialDataType.PURCHASE_ORDER)
      .reduce((total, offer) => total + offer.financialDatas.length, 0);

    total += this.financialDatas.filter((x) => x.type === FinancialDataType.INVOICE).length;
    return total;
  }

  get consumedExpensesInvoicesAmountBt() {
    let total = 0;

    for (let fd of this.financialDatas.filter((x) => x.type === FinancialDataType.PURCHASE_ORDER)) {
      for (let invoice of fd.financialDatas) {
        total += invoice.consumed_amount_bt;
      }
    }
    for (let fd of this.financialDatas.filter((x) => x.type === FinancialDataType.INVOICE)) {
      total += fd.consumed_amount_bt;
    }

    return total;
  }

  get consumedExpensesReportCount() {
    return this.financialDatas.filter((x) => x.type === FinancialDataType.EXPENSE_REPORT_EXPENSE).length;
  }

  get consumedExpensesReportAmountBt() {
    let total = 0;

    for (let fd of this.financialDatas.filter((x) => x.type === FinancialDataType.EXPENSE_REPORT_EXPENSE)) {
      total += fd.consumed_amount_bt;
    }
    return total;
  }
  get consumedPlanningCount() {
    return this.financialDatas.filter((x) => x.type === FinancialDataType.PLANNING).length;
  }

  get consumedPlanningAmountBt() {
    let total = 0;

    for (let fd of this.financialDatas.filter((x) => x.type === FinancialDataType.PLANNING)) {
      total += fd.consumed_amount_bt;
    }
    return total;
  }
  // PROJETE RECETTES
  get projectedIncomesInvoicesCount() {
    let total = 0;

    total += this.financialDatas.filter((x) => x.type === FinancialDataType.INVOICE && x.status !== "DRAFT").length;

    return total;
  }

  get projectedIncomesContractsNotInvoicedCount() {
    let total = 0;

    total += this.financialDatas.filter((x) => x.type === FinancialDataType.CONTRACT_INVOICE).length;

    return total;
  }
  get projectedOffersCount() {
    return this.financialDatas.filter((x) => x.type === FinancialDataType.OFFER && x.status === "VALIDATED").length;
  }

  get projectedOffersAmountBt() {
    let total = 0;

    for (let fd of this.financialDatas.filter((x) => x.type === FinancialDataType.OFFER && x.status === "VALIDATED")) {
      total += fd.projected_amount_bt;
    }
    return total;
  }
  get projectedInvoicesAmountBt() {
    let total = 0;

    for (let fd of this.financialDatas.filter((x) => x.type === FinancialDataType.INVOICE && x.status !== "DRAFT")) {
      total += fd.projected_amount_bt;
    }

    return total;
  }

  get projectedContractsNotInvoicedAmountBt() {
    let total = 0;

    for (let fd of this.financialDatas.filter((x) => x.type === FinancialDataType.CONTRACT_INVOICE)) {
      total += fd.projected_amount_bt;
    }
    return total;
  }

  // PROJETE DEPENSES

  get projectedPurchaseOrdersCount() {
    let total = 0;

    total += this.financialDatas.filter((x) => x.type === FinancialDataType.PURCHASE_ORDER).length;
    return total;
  }

  get projectedPurchaseOrdersAmountBt() {
    let total = 0;

    for (let fd of this.financialDatas.filter((x) => x.type === FinancialDataType.PURCHASE_ORDER)) {
      total += fd.projected_amount_bt;
    }

    return total;
  }

  get projectedExpensesInvoicesCount() {
    return this.financialDatas.filter((x) => x.type === FinancialDataType.INVOICE).length;
  }

  get projectedExpensesInvoicesAmountBt() {
    let total = 0;

    for (let fd of this.financialDatas.filter((x) => x.type === FinancialDataType.INVOICE)) {
      total += fd.projected_amount_bt;
    }
    return total;
  }

  get projectedExpensesReportCount() {
    return this.financialDatas.filter((x) => x.type === FinancialDataType.EXPENSE_REPORT_EXPENSE).length;
  }

  get projectedExpensesReportAmountBt() {
    let total = 0;

    for (let fd of this.financialDatas.filter((x) => x.type === FinancialDataType.EXPENSE_REPORT_EXPENSE)) {
      total += fd.projected_amount_bt;
    }
    return total;
  }
  get projectedPlanningCount() {
    return this.financialDatas.filter((x) => x.type === FinancialDataType.PLANNING).length;
  }

  get projectedPlanningAmountBt() {
    let total = 0;

    for (let fd of this.financialDatas.filter((x) => x.type === FinancialDataType.PLANNING)) {
      total += fd.projected_amount_bt;
    }
    return total;
  }

  constructor() {}

  public static createInstance(jsonData: FinancialDatas): FinancialDatas {
    const p = Object.assign(new FinancialDatas(), jsonData);

    if (jsonData.financialDatas) {
      p.financialDatas = FinancialData.createInstances(jsonData.financialDatas);
    }

    return p;
  }

  clone(): FinancialDatas {
    const copy = new FinancialDatas();
    Object.assign(copy, JSON.parse(JSON.stringify(this)));
    return copy;
  }
}
